export const Discipline = Object.freeze({
  development: 'development',
  marketing: 'marketing',
  design: 'design',
  multimedia: 'multimedia',
});
